module.exports = __webpack_public_path__ + "img/color-success.2de2d4e0.png";